export default __webpack_public_path__ + "27e31883f184167e861a1f06aab81817.jpg";